export default "__VITE_ASSET__f673f546__"